import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { SelectItem } from 'primeng/components/common/selectitem';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';


@Component({
  selector: 'mf-column-selector',
  templateUrl: './mf-column-selector.component.html',
  styleUrls: ['./mf-column-selector.component.css']
})
export class MfColumnSelectorComponent implements OnInit {
  _loading: boolean = false;
  @Input()
  set loading(value) {
    this._loading = value;
    this.loadingChange.emit(this._loading);
  }
  get loading() {
    return this._loading;
  }
  @Input()
  set selectedColumns(value) {
    this._selectedColumns = value;
    this._selectedColumnFields = this._selectedColumns.map(item => {
      return item.field
    });
    this.selectedColumnsChange.emit(this._selectedColumns);
  }
  get selectedColumns() {
    var selectedCols = new Array();
    this._selectedColumnFields.forEach(o => {
      var filt = this.staticColumns.filter(function (i) {
        return i.field == o;
      });
      selectedCols.push(filt[0]);
    })
    return selectedCols;
  }
  _selectedColumnFields: any = new Array();
  set selectedColumnFields(value) {
    this._selectedColumnFields = value;
  }
  get selectedColumnFields() {
    return this._selectedColumnFields
  }

  _columns: any[];
  get columns() {
    return this._columns;
  }
  @Input() set columns(value) {
    this._columns = value.filter(o=>typeof (o.visible) == 'undefined' || o.visible) .map(item => {
      return {label : item.name, value:item.field}
    });
  }
  public colTest: any = new Array;
  _selectedColumns: any[];
  @Input() staticColumns: any[];
  @Output() selectedColumnsChange = new EventEmitter();
  @Output() columnsChange = new EventEmitter();
  @Output() loadingChange = new EventEmitter();

  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef) {
    this.columns = config.data.columns;
    this.selectedColumns = config.data.selectedColumns;
    this.staticColumns = config.data.staticColumns;
   // this.colTest = config.data.columns;
    //this.cdr.detectChanges();
  }

  ngOnInit() {
  }

  public done() {
    
    this.ref.close(this.selectedColumns);
  }

}
